<template>
  <el-row>
    <h6 style="text-align: left; margin-top: 20px">待回本额: </h6>
    <el-alert
      :closable="false"
      type="error"
      v-if="!costInfo">
      <i class="el-icon-star-on"></i> <span>系统中暂未发现相关记录</span>
    </el-alert>
    <el-row style="margin-top: 15px" v-if="this.$store.state.CurrentUser != 'super_admin'">
      <div v-if="costInfo">
        {{ costInfo.leftCost }}
      </div>
      <div v-else>Na</div>
    </el-row>
    <el-row style="margin-top: 15px" v-else>
      <el-col :span="6">
        <el-input v-model="costInfoForm.cost" placeholder="请输入需要回本金额，单位：分！"></el-input>
      </el-col>
      <el-col :offset="3" :span="2">
        <el-button size="small" type="primary" @click="onClickUpdateCost"><i
          class="el-icon-edit"></i> {{ costInfo ? '更改' : '新增' }}
        </el-button>
      </el-col>
    </el-row>

    <el-dialog
      title="温馨提示"
      :visible.sync="confirmUpdateCostInfo"
      width="30%">
      <span>商家回本额度是非常重要的信息，单位精确到分，请确认更改没有问题？</span>
      <span slot="footer" class="dialog-footer">
            <el-button @click="confirmUpdateCostInfo = false">取 消</el-button>
            <el-button type="primary" @click="updateCostInfo">确 定</el-button>
          </span>
    </el-dialog>

    <h6 style="text-align: left; margin-top: 20px">收入明细: </h6>
    <el-table
      :data="incomes.slice((incomesForm.page - 1) * incomesForm.pageSize, incomesForm.page * incomesForm.pageSize)"
      border
      style="width: 100%">
      <el-table-column
        prop="payOrderId"
        label="支付订单ID"
        width="220">
      </el-table-column>
      <el-table-column
        prop="originalAmount"
        label="原始订单金额">
        <template slot-scope="scope">
          {{ scope.row.originalAmount }} 分
        </template>
      </el-table-column>
      <el-table-column
        prop="shareRatio"
        sortable
        label="提成比例">
        <template slot-scope="scope">
          {{ scope.row.shareRatio }}%
        </template>
      </el-table-column>
      <el-table-column
        prop="shareMoney"
        sortable
        label="提成金额">
        <template slot-scope="scope">
          {{ scope.row.shareMoney }} 分
        </template>
      </el-table-column>
      <el-table-column
        prop="comment"
        label="备注">
      </el-table-column>

      <el-table-column
        prop="dateStr"
        sortable
        label="发生时间">
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      v-if="totalIncomesElements > 0"
      background
      layout="prev, pager, next"
      :current-page.sync="incomesForm.page"
      :page-size="incomesForm.pageSize"
      :total="totalIncomesElements">
    </el-pagination>

    <h6 style="text-align: left; margin-top: 20px">保养记录: </h6>
    <el-table
      :data="maintains"
      border
      style="width: 100%">
      <el-table-column
        prop="id"
        label="编号">
      </el-table-column>
      <el-table-column
        prop="customer"
        label="用户编号">
        <template slot-scope="scope">
          <router-link :to="{path: '/user/details', query: {id: scope.row.customer}}">{{ scope.row.customer }}
          </router-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="payId"
        label="支付订单号">
      </el-table-column>
      <el-table-column
        prop="oil"
        label="用油类型">
      </el-table-column>
      <el-table-column
        prop="volume"
        label="用油升数">
        <template slot-scope="scope">
          {{ scope.row.volume }} 升
        </template>
      </el-table-column>

      <el-table-column
        prop="surcharge"
        label="额外支付">
        <template slot-scope="scope">
          {{ scope.row.surcharge / 100 }} 元
        </template>
      </el-table-column>
      <el-table-column
        prop="amount"
        label="总支付">
        <template slot-scope="scope">
          {{ scope.row.amount / 100 }} 元
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态">
        <template slot-scope="scope">
          {{ scope.row.status == '0' ? '保养中' : (scope.row.status == '1' ? '核销完成' : '核销失败') }}
        </template>
      </el-table-column>
      <el-table-column
        prop="hourFee"
        label="工时费">
        <template slot-scope="scope">
          {{ scope.row.hourFee / 100 }} 元
        </template>
      </el-table-column>
      <el-table-column
        prop="et"
        label="发生时间">
        <template slot-scope="scope">
          {{ scope.row.et.substring(0, 10) }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      v-if="totalMaintainElements > 0"
      background
      layout="prev, pager, next"
      @current-change="handleMaintainPageChange"
      :current-page.sync="maintainForm.page"
      :page-size="maintainForm.pageSize"
      :total="totalMaintainElements">
    </el-pagination>
  </el-row>
</template>

<script>
import * as api from "@/js/api.js"

export default {
  name: "OperationData",
  props: {
    providerId: String,
    costInfo: Object,
    incomes: Array,
    totalIncomesElements: Number,
    maintains: Array,
    totalMaintainElements: Number
  },

  data() {
    return {
      maintainForm: {
        page: 1,
        pageSize: 20
      },
      incomesForm: {
        page: 1,
        pageSize: 10
      },
      costInfoForm: {
        cost: 0,
      },
      confirmUpdateCostInfo: false,
      currentUser: this.$store.state.CurrentUser
    }
  },

  methods: {
    handleMaintainPageChange() {
      this.$emit('maintainListPageChange', this.maintainForm);
    },

    onClickUpdateCost() {
      this.confirmUpdateCostInfo = true
    },

    updateCostInfo() {
      this.confirmUpdateCostInfo = false
      const params = {
        providerId: this.providerId,
        cost: this.costInfoForm.cost
      }

      api.updateCostInfo(params).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('后台服务出错');
        } else {
          this.$message.success('操作成功')
          this.$emit('refresh')
        }
      })
    },
  },

  watch: {
    'costInfo.leftCost': function (val) {
      this.costInfoForm.cost = val;
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/providers/operation_data/OperationData.vue